export default __webpack_public_path__ + "images/371e9f6103a79fdaa260b57354cdaf38.jpg";